import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { vasthuUrl } from "../../component/Api";
import chatingbg from "../../images/chatingbg.jpg";
import { useTranslation } from "react-i18next";
import Toast from "../../component/Toast";

const ChatHistoryView = ({ show, onClose, meetingCode }) => {
  const { t } = useTranslation();
  const token = sessionStorage.getItem("token");

  const [chatData, setChatData] = useState();
  const [loading, setLoading] = useState(false);

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg) => {
    setMessage(msg);
    setToastTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (show && meetingCode) {
      setLoading(true);
      vasthuUrl
        .get(`/getChatRecords/${meetingCode}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setChatData(res.data))
        .catch((err) => {
          console.error("Chat fetch error:", err);
          alert(t("TXT.ERR.FETCH.CHAT") || "Failed to load chat history.");
          setMessageType("error");
        })
        .finally(() => setLoading(false));
    }
  }, [show, meetingCode, t, token]);

  return (
    <>
      <Toast msg={message} type={messageType} trigger={toastTrigger} />
      <Modal show={show} onHide={onClose} fullscreen centered>
        <div className="chat_view_main">
          <div
            className="chat_view_back"
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundImage: `url(${chatingbg})`,
              backgroundSize: "cover",
              backgroundBlendMode: "overlay",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "20px",
            }}
          >
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {loading ? (
                <li className="text-center my-3">Loading...</li>
              ) : chatData?.messages?.length > 0 ? (
                chatData.messages.map((chat, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent:
                        chat.role === "ROLE_USER" ? "flex-end" : "flex-start",
                      margin: "10px 0",
                      overflowWrap: "anywhere",
                    }}
                  >
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor:
                          chat.role === "ROLE_USER" ? "#d1e7dd" : "#f8d7da",
                        borderRadius: "10px",
                        maxWidth: "70%",
                      }}
                    >
                      {chat.role === "ROLE_USER" ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: chat.message.replaceAll("\n", "<br />"),
                          }}
                        />
                      ) : (
                        <>
                          <strong>{chat.senderName}: </strong>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: chat.message.replaceAll("\n", "<br />"),
                            }}
                          />
                        </>
                      )}
                    </div>
                  </li>
                ))
              ) : (
                <li className="text-center my-3">
                  {t("TXT.NO.REC.FUD.LO") || "No Records Found"}
                </li>
              )}
            </ul>
          </div>
        </div>
        <Modal.Footer>
          <Button className="all_btn" onClick={onClose}>
            {t("TXT.CLOSE") || "Close"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChatHistoryView;
